import HistoricalOrderInquiry from './historical-order-inquiry.vue'
export default HistoricalOrderInquiry
